import LiberarSolicitacoes from './componentes/LiberarSolicitacoes.vue';

export default {
  path: '/liberar-solicitacoes',
  component: LiberarSolicitacoes,
  meta: { auth: true },
  name: 'liberar-solicitacoes',
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-solicitacoes/rotas.js